import { render, staticRenderFns } from "./q7.vue?vue&type=template&id=0f9868dc&scoped=true&"
import script from "./q7.vue?vue&type=script&lang=js&"
export * from "./q7.vue?vue&type=script&lang=js&"
import style0 from "./q7.vue?vue&type=style&index=0&id=0f9868dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9868dc",
  null
  
)

export default component.exports